module.exports = __webpack_public_path__ + "static/media/Asurion-header.ac6abc43.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-ASURION/Asurion-header.png
// module id = 3745
// module chunks = 0